{
    "coordinates": [
        -44.870619345864405,
        169.81340594624066
    ],
    "tooltip": "St. Bathans",
    "title": "St. Bathans Fauna",
    "country": "New Zealand",
    "period": "Neogene",
    "alt": "TODO"
}
